/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { RichTextComponent } from '@msdyn365-commerce/core';
import * as React from 'react';
import { TosCheckbox } from './components/tos-checkbox';
import { IPageTosViewProps } from './page-tos';

export default (props: IPageTosViewProps) => {
    return (
        <div className='page-tos'>
            <RichTextComponent text={props.config.tosText} className='page-tos-text' />
            <TosCheckbox props={props} />
        </div>
    );
};
